// removed by extract-text-webpack-plugin
module.exports = {"invoiceWrapper":"_3k48Sgbacbx3meTBJHoBKj","headerWrapper":"_1F81raLt8sSqRIL-9xJzDq","formWrapper":"_8sPr8wTiMmL7_uQRsfjsm","totalBlock":"_2dnQf59oaah08D0Ud6dMzi","boldText":"_1Go4VrQBxFS1HPtsVQH32w","inputWrapper":"_3MC_poI7hCAc10pRmUKgVh","errorMsg":"KbiBa8994A-rKXVAXwA23","quantity":"_3R4Q5OoudrhUZ9HuW2jf4y"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/DetailsToInvoiceForm/DetailsToInvoiceForm.scss
// module id = 791
// module chunks = 0